import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M13 4h6l.5 4 2 1L25 7.5l3 5-3.5 2.5v2l3.5 2.5-3 5-3.5-1.5-2 1-.5 4h-6l-.5-4-2-1L7 24.5l-3-5L7.5 17v-2L4 12.5l3-5L10.5 9l2-1 .5-4zm3 16a4 4 0 100-8 4 4 0 000 8z"
      fill="none"
    />
  </Icon>
);
